


// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import '../blog.css'

// const BlogSection = () => {
//   const [blogs, setBlogs] = useState([]);
//   // --- CHANGE 1: State to manage the number of visible blogs ---
//   const [visibleBlogs, setVisibleBlogs] = useState(6); // Show 6 blogs initially

//   useEffect(() => {
//     fetch("https://satvicpath.com/wordpress/wp-json/wp/v2/posts?_embed")
//       .then((res) => {
//         if (!res.ok) {
//           throw new Error('Network response was not ok');
//         }
//         return res.json();
//       })
//       .then((data) => {
//         const formatted = data.map((post) => ({
//           slug: post.slug,
//           title: post.title.rendered,
//           date: new Date(post.date).toLocaleDateString(),
//           author: post._embedded.author[0].name,
//           excerpt: post.excerpt.rendered.replace(/<[^>]+>/g, ""),
//           image: post._embedded["wp:featuredmedia"]
//             ? post._embedded["wp:featuredmedia"][0].source_url
//             : "https://via.placeholder.com/400x200",
//         }));
//         setBlogs(formatted);
//       })
//       .catch((error) => {
//         console.error("There was a problem with the fetch operation:", error);
//       });
//   }, []);

//   // --- CHANGE 2: Function to load more blogs ---
//   const handleShowMore = () => {
//     setVisibleBlogs((prevVisibleBlogs) => prevVisibleBlogs + 6); // Increase by 6
//   };

//   return (
//     <section className="blog-section" id="blogs">
//       <h1 className="blog-heading">Blogs</h1>
//       <p className="sec-subtitle">Insights for your satvic journey</p>

//       <div className="blog-grid">
//         {/* --- CHANGE 3: Slice the array to show only a limited number of blogs --- */}
//         {blogs.slice(0, visibleBlogs).map((blog) => (
//           <div className="blog-card" key={blog.slug}>
//              <Link to={`/post/${blog.slug}`}>
//               <img src={blog.image} alt={blog.title} className="blog-image" />
//             </Link>
//             <div className="blog-meta">
//               <p className="blog-author">Pragya |  {blog.date}</p>
//               <Link to={`/post/${blog.slug}`}>
//                 <h2 className="blog-title">{blog.title}</h2>
//               </Link>
//               <p className="blog-excerpt">{blog.excerpt}</p>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* --- CHANGE 4: Conditionally render the "Show More" button --- */}
//       {visibleBlogs < blogs.length && (
//         <div className="show-more-container">
//           <button  className="show-more-btn">
//             <Link to="/blogs" style={{textDecoration:'none', color:"white"}}>Show More Blogs</Link>
//           </button>
//         </div>
//       )}
//     </section>
//   );
// };


// export default BlogSection;              
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import '../blog.css';

const BlogSection = () => {
  const [blogs, setBlogs] = useState([]);
  const [visibleBlogs, setVisibleBlogs] = useState(6); // Show 6 blogs initially

  useEffect(() => {
    // Note: Updated the fetch URL to include the content field needed for read time
    fetch("https://satvicpath.com/wordpress/wp-json/wp/v2/posts?_embed")
      .then((res) => {
        if (!res.ok) {
          throw new Error('Network response was not ok');
        }
        return res.json();
      })
      .then((data) => {
        const formatted = data.map((post) => {
          // --- READ TIME CALCULATION ---
          // 1. Get raw content text and strip HTML tags
          const rawContent = post.content.rendered.replace(/<[^>]+>/g, "");
          // 2. Count words
          const wordCount = rawContent.trim().split(/\s+/).length;
          // 3. Calculate minutes (avg 200 wpm)
          const minutes = Math.ceil(wordCount / 200);

          return {
            slug: post.slug,
            title: post.title.rendered,
            // Formatted date (e.g., Oct 24, 2024)
            date: new Date(post.date).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            }),
            author: post._embedded.author[0].name,
            excerpt: post.excerpt.rendered.replace(/<[^>]+>/g, ""),
            image: post._embedded["wp:featuredmedia"]
              ? post._embedded["wp:featuredmedia"][0].source_url
              : "https://via.placeholder.com/400x200",
            readTime: minutes,
          };
        });
        setBlogs(formatted);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  }, []);

  // Use this if you want the button to expand the list on the same page
  const handleShowMore = () => {
    setVisibleBlogs((prev) => prev + 6);
  };

  return (
    <section className="blog-section" id="blogs">
      <h1 className="blog-heading">Blogs</h1>
      <p className="sec-subtitle">Insights for your satvic journey</p>

      <div className="blog-grid">
        {blogs.slice(0, visibleBlogs).map((blog) => (
          <div className="blog-card" key={blog.slug}>
            <Link to={`/post/${blog.slug}`}>
              <img src={blog.image} alt={blog.title} className="blog-image" />
            </Link>
            <div className="blog-meta">
              {/* Added the dynamic Read Time here */}
              <p className="blog-author">
              {blog.date} | {blog.readTime} min read
              </p>
              <Link to={`/post/${blog.slug}`}>
                <h2 className="blog-title">{blog.title}</h2>
              </Link>
              <p className="blog-excerpt">{blog.excerpt}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Conditionally render the button container */}
      {visibleBlogs < blogs.length && (
        <div className="show-more-container">
          {/* NOTE: If you want to link to a separate "All Blogs" page, keep the Link. 
            If you want to just load more on THIS page, change to: onClick={handleShowMore} 
          */}
          <button className="show-more-btn">
            <Link to="/blogs" style={{ textDecoration: 'none', color: "white" }}>
              Show More Blogs
            </Link>
          </button>
        </div>
      )}
    </section>
  );
};

export default BlogSection;